import { ConnectionDetailType } from '~src/datasource/dataConnection/serverApi/types/ConnectionDetail';
import { ICertifiableItemInfo,INamedItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

export type ConnectionDetailInfoType = ConnectionDetailType;

export type ConnectionDetailInfo = DatabaseConnectionDetailInfo
                                 | TableauServerConnectionDetailInfo
                                 | TableauServerSiteConnectionDetailInfo
                                 | FileConnectionDetailInfo
                                 | WebDataThirdPartyConnectionDetailInfo
                                 | VirtualConnectionConnectionDetailInfo;

export interface EmbeddedPasswordDetailInfo {
  hasEmbeddedPassword: boolean;
}

export interface RemoteConnectionDetailInfo extends EmbeddedPasswordDetailInfo {
  serverName: string;
  serverPort?: string;
  databaseUsername?: string;
}

export interface DatabaseConnectionDetailInfo extends RemoteConnectionDetailInfo {
  type: 'database';
  instanceUrl: string;
  role: string;
  oauthConfigId: string;
  authenticationType?: string;
}

export interface TableauServerConnectionDetailInfo extends EmbeddedPasswordDetailInfo, INamedItemInfo {
  type: 'tableauserver';
  certificationDetails: ICertifiableItemInfo;
}

export interface TableauServerSiteConnectionDetailInfo extends EmbeddedPasswordDetailInfo {
  type: 'tableauserversite';
  siteUrl: string;
}

export interface FileConnectionDetailInfo extends EmbeddedPasswordDetailInfo {
  type: 'file';
  fileName: string;
}

export interface WebDataThirdPartyConnectionDetailInfo extends RemoteConnectionDetailInfo {
  type: 'webdata-direct';
}

export interface VirtualConnectionConnectionDetailInfo extends EmbeddedPasswordDetailInfo, INamedItemInfo {
  type: 'virtualconnection';
  url: string;
}

export function isRemote(d: ConnectionDetailInfo): d is DatabaseConnectionDetailInfo | WebDataThirdPartyConnectionDetailInfo {
  return d.type === 'database' || d.type === 'webdata-direct';
}

export const isSameConnectionDetailInfo = (left: ConnectionDetailInfo) => (right: ConnectionDetailInfo) => {
  if (left === null || right === null || left.type !== right.type) {
    return false;
  }
  switch (left.type) {
    case 'file':
      return isSameFileConnectionDetailInfo(left, right as FileConnectionDetailInfo);
    case 'tableauserver':
      return isSameTableauServerConnectionDetailInfo(left, right as TableauServerConnectionDetailInfo);
    case 'tableauserversite':
      return isSameTableauServerSiteConnectionDetailInfo(left, right as TableauServerSiteConnectionDetailInfo);
    case 'virtualconnection':
      return isSameVirtualConnectionConnectionDetailInfo(left,right as VirtualConnectionConnectionDetailInfo);
    default:
      return isSameRemoteConnectionDetailInfo(left, right as RemoteConnectionDetailInfo);
  }
};

function isSameFileConnectionDetailInfo(left: FileConnectionDetailInfo, right: FileConnectionDetailInfo): boolean {
  return left.fileName === right.fileName;
}

function isSameTableauServerConnectionDetailInfo(
  left: TableauServerConnectionDetailInfo,
  right: TableauServerConnectionDetailInfo
): boolean {
  return left.id === right.id;
}

function isSameTableauServerSiteConnectionDetailInfo(
  left: TableauServerSiteConnectionDetailInfo,
  right: TableauServerSiteConnectionDetailInfo
): boolean {
  return left.siteUrl === right.siteUrl;
}

function isSameRemoteConnectionDetailInfo(left: RemoteConnectionDetailInfo, right: RemoteConnectionDetailInfo): boolean {
  return left.serverName === right.serverName && left.serverPort === right.serverPort;
}

function isSameVirtualConnectionConnectionDetailInfo(
  left: VirtualConnectionConnectionDetailInfo,
  right: VirtualConnectionConnectionDetailInfo
): boolean {
  return left.name === right.name && left.url === right.url;
}
